module.exports = __webpack_public_path__ + "img/banner.f15ac468.jpg";